import { getLanguagePrefix } from "../../utils/languageUtils";

const getHomePath = () => {
  const prefix = getLanguagePrefix(window.location.pathname);
  return prefix || '/';
};

/**
 * Generate mobile header navigation data with translation function
 * Mobile menu shows simplified version with only Špecializácia dropdown
 */
export const generateHeaderDataMobile = (t, getLocalizedPath) => [
  {
    id: "sluzby-menu-item",
    title: t('common:nav.services'),
    className: "menu-item-link",
    onClick: () => {
      const sectionId = "services";
      const currentPath = window.location.pathname;
      const homePath = getHomePath();

      if (currentPath !== homePath && currentPath !== homePath + '/') {
        sessionStorage.setItem("scrollToSection", sectionId);
        window.location.href = homePath;
        return;
      }
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: "smooth" });
    },
    megamenu: [
      {
        title: t('common:nav.specialization'),
        dropdown: [
          {
            title: t('common:nav.wholesale'),
            link: getLocalizedPath("/#services"),
            onClick: () => {
              const sectionId = "services";
              const currentPath = window.location.pathname;
              const homePath = getHomePath();

              if (currentPath !== homePath && currentPath !== homePath + '/') {
                sessionStorage.setItem("scrollToSection", sectionId);
                window.location.href = homePath;
              }
            },
          },
          {
            title: t('common:nav.otcMedication'),
            link: getLocalizedPath("/#services"),
            onClick: () => {
              const sectionId = "services";
              const currentPath = window.location.pathname;
              const homePath = getHomePath();

              if (currentPath !== homePath && currentPath !== homePath + '/') {
                sessionStorage.setItem("scrollToSection", sectionId);
                window.location.href = homePath;
              }
            },
          },
          {
            title: t('common:nav.construction'),
            link: getLocalizedPath("/marketing-pre-stavebnictvo"),
            onClick: () => {
              window.location.href = getLocalizedPath("/marketing-pre-stavebnictvo");
            },
          },
          {
            title: t('common:nav.floorStudios'),
            link: getLocalizedPath("/marketing-pre-podlahy"),
            onClick: () => {
              window.location.href = getLocalizedPath("/marketing-pre-podlahy");
            },
          },
          {
            title: t('common:nav.marketEntry'),
            link: getLocalizedPath("/#services"),
            onClick: () => {
              const sectionId = "services";
              const currentPath = window.location.pathname;
              const homePath = getHomePath();

              if (currentPath !== homePath && currentPath !== homePath + '/') {
                sessionStorage.setItem("scrollToSection", sectionId);
                window.location.href = homePath;
              }
            },
          },
          {
            title: t('common:nav.yourSegment'),
            link: "#",
            modalAction: "openContactModal",
          },
        ],
      },
    ],
  },
  {
    id: "ai-offer-menu-item",
    title: t('common:nav.aiOffer'),
    link: "https://ai.inaq.sk",
    external: true,
    className: "menu-item-link",
  },
  {
    id: "blog-menu-item",
    title: t('common:nav.blog'),
    link: getLocalizedPath("/blog"),
    className: "menu-item-link",
  },
  {
    id: "pricelist-menu-item",
    title: t('common:nav.pricelist'),
    link: getLocalizedPath("/#pricelist"),
    className: "menu-item-link",
    scrollTo: "pricelist",
  },
  {
    id: "kariera-menu-item",
    title: t('common:nav.career'),
    className: "menu-item-link",
    notification: {
      count: 1,
      animate: true,
    },
    link: getLocalizedPath("/#careers"),
    scrollTo: "careers",
  },
  {
    id: "newsletter-menu-item",
    title: t('common:nav.newsletter'),
    className: "menu-item-link",
    link: getLocalizedPath("/#newsletter"),
    scrollTo: "newsletter",
  },
  {
    id: "contact-menu-item",
    title: t('common:nav.contact'),
    className: "menu-item-link",
    link: getLocalizedPath("/#contact"),
    scrollTo: "contact",
  },
];
